





















import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

import PresetService from '@/services/user_preset_service';

@Component({
  name: 'BlockCard',
  components: {
  }
})
export default class  extends Vue {
  @Prop() public blockTitle!: string;
  @Prop({default: false}) public showDouble: boolean;
  @Prop({default: true}) public colorText: boolean;
  @Prop() public blockId!: string;
  @Prop({default: () => {
    return {
      first: false,
      second: false,
      third: false,
      fourth: false,
      fifth: false,
      sixth: false,
    }
  }}) public rowVisible!: any;

  get route() {
    return this.$route.name
  }

  get cssVars() {
    return {
      height: this.rowHeight + 'px', '--width': PresetService.cardWidth + 'px'
    }
  }

  get fixedWidth() {
    return {height: this.rowHeight + 'px', '--width': '165px'}
  }

  get highlight() {
    let total = '';
    if(this.colorText) {total='total';}
    return total;
  }

  get rowHeight() {
    if(this.route === 'losses') {
      return 220
    }
    let count = 2;
    for(let key in this.rowVisible) {
      if(this.rowVisible[key]) count += 1
    }
    return (25 * count) + 22
  }
}
